module.exports = __webpack_public_path__ + "images/img-3CnOOsU.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/ranks/1.png
// module id = 1758
// module chunks = 0